var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKr(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 55,
    height: 41,
    x: -1,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h53.3v40H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M0 0h53.3v40H0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    fillRule: "evenodd",
    d: "m5.8 12.2 5.6-8.4 1.4 1L7.2 13zM8 13.5l5.6-8.3 1.4 1-5.6 8.3zm2 1.5 5.6-8.3 1.3 1-5.5 8.3zm26.3 17.5 5.6-8.3 1.4.9-5.6 8.3zm2.1 1.4 5.6-8.3 1.4.9-5.6 8.3zm2.1 1.4 5.6-8.3 1.3.9-5.5 8.3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m38.4 27.9 7 4.6Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 1.3,
    d: "m38.4 27.9 7 4.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cd2e3a",
    fillRule: "evenodd",
    d: "M18.3 14.5a10 10 0 0 1 16.7 11z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0047a0",
    fillRule: "evenodd",
    d: "M18.3 14.5a10 10 0 0 0 16.7 11 5 5 0 1 0-8.4-5.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cd2e3a",
    d: "M26.6 20a5 5 0 1 0-8.3-5.5 5 5 0 0 0 8.3 5.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    fillRule: "evenodd",
    d: "M11.4 36.2 6 27.9l1.4-1 5.5 8.4zm2-1.4L8 26.5l1.4-1L15 34zm2.2-1.4L10 25.1l1.4-1 5.6 8.4zM42 15.9l-5.6-8.4 1.4-.9 5.5 8.3zm2-1.4L38.5 6l1.3-.9 5.6 8.3zm2-1.4-5.5-8.3 1.4-1 5.6 8.4z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m10.4 30.9 2-1.4Zm28-18.7 2.5-1.7Zm4.6-3 2-1.4Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 1.3,
    d: "m10.4 30.9 2-1.4m26-17.3 2.5-1.7m2-1.3L45 7.8"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h53.3v40H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKr);
export default __webpack_public_path__ + "static/media/kr.dfd9ace3093911d88938439c8a78afe4.svg";
export { ForwardRef as ReactComponent };